
import { sanPhamApi } from '../../../api/san-pham/sanPhamApi';
import { ISanPhamEditRequest } from '../../../model/request/san-pham/ISanPhamEditRequest';
import { ISanPhamImportRequest } from '../../../model/request/san-pham/ISanPhamImportRequest';
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { eSanPhamActionTypeIds, ISanPhamActions } from '../../action-types/san-pham/ISanPhamActionType';
import { rootActions } from '../../actions/rootActions';

import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
const mainAction = rootActions.sanPham.sanPham;
export function* sanPhamSaga(): any {
    yield takeLatest(eSanPhamActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eSanPhamActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eSanPhamActionTypeIds.DELETE_START, deleteWorker)
    yield takeEvery(eSanPhamActionTypeIds.SAVE_IMPORT_START, saveImportWorker)
}

function* loadWorker(action: ISanPhamActions): any {
    const payload = action.payload as { dm_coso_id?: number } | undefined;
    const cosoId = parseInt(localStorage.getItem("dm_coso_id") ?? "0") || 0;
    const requestParams: { dm_coso_id: number } = {
        dm_coso_id: payload?.dm_coso_id || cosoId,
    };

    const res: IBaseRespone = yield call(sanPhamApi.SelectAll, requestParams);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: ISanPhamActions): any {

    const payload = action.payload as ISanPhamEditRequest;
    const res = yield call(sanPhamApi.SaveChange, payload)
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
        yield put(rootActions.sanPham.sanPhamChiTiet.LOAD_START(undefined))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: ISanPhamActions): any {
    const res: IBaseRespone = yield call(sanPhamApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
        // Reload lại danh sách sản phẩm sau khi xóa thành công
        yield put(mainAction.LOAD_START(undefined))
        yield put(rootActions.sanPham.sanPhamChiTiet.LOAD_START(undefined))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveImportWorker(action: ISanPhamActions): any {
    const res: IBaseRespone = yield call(sanPhamApi.SaveDataExcelCombined, action.payload as ISanPhamImportRequest)
    if (res.is_success) {
        yield put(mainAction.SAVE_IMPORT_SUCCESS(res.data))
        // Reload lại danh sách sản phẩm và sản phẩm chi tiết sau khi import thành công
        yield put(mainAction.LOAD_START(undefined))
        yield put(rootActions.sanPham.sanPhamChiTiet.LOAD_START(undefined))
    } else {
        yield put(mainAction.SAVE_IMPORT_ERROR(res.message ?? "Có lỗi"))
    }
}